module.exports = __webpack_public_path__ + "static/historyImage-0be70ce039e9d0da76412772c64b9c11.jpg";